import { Helmet } from "react-helmet-async";

const SITE = "Clocktower Cars Gatwick";
const DEFAULT_DESC = "Gatwick's premier private hire & airport transfers. Fixed-price, 24/7 licensed taxis and chauffeur-driven Mercedes across Crawley, Gatwick and Surrey.";

export const Seo = ({ title, description, path = "", image, type = "website", jsonLd = [] }) => {
  const fullTitle = title
    ? (/clocktower/i.test(title) ? title : `${title} | ${SITE}`)
    : `${SITE} | Private Hire & Airport Transfers`;
  const desc = description || DEFAULT_DESC;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const img = image ? (image.startsWith("http") ? image : `${origin}${image}`) : `${origin}/videos/hero-poster.jpg`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schemas.filter(Boolean).map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};
